import { BaseEntity } from '~/app/core/models/base-entity.model';
import { Language } from '~/app/core/models/language.interface';

export class ProfileConfig extends BaseEntity<ProfileConfig> {
  timezone?: string;
  language?: Language;
}
